<template>
  <div class="home-views">

    <div class="banner-wrapper">
      <el-carousel trigger="click" height="350px" arrow="never">
        <el-carousel-item v-for="(banner, index) in bannerList" :key="index">
          <a class="banner-link">
            <img :src="banner.bannerUrl" alt="" class="image">
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div>
      <div class="floor-wrapper" v-for="(floor, index) in floorList" :key="index">
        <cloud-floor :floor="floor" :index="index">
          <cloud-floor-tab :floor="floor" :index="index" @currentTab="tabChange">
            <floor-video-a-d
              :floor="floorData[index]"
              :index="index"
              v-if="floor && floor.bannerResourceEntityList && floor.bannerResourceEntityList.length > 0"/>
            <floor-video
              :floor="floorData[index]"
              :index="index"
              v-if="floor && floor.bannerResourceEntityList && floor.bannerResourceEntityList.length <= 0 && floor && floor.videoResourceEntityList && floor.videoResourceEntityList.length > 0"/>
            <floor-resource
              :floor="floorData[index]"
              :index="index"
              v-if="floor && floor.documentResourceEntityList && floor.documentResourceEntityList.length > 0"/>
            <floor-link
              :floor="floorData[index]"
              :index="index"
              v-if="floor && floor.fixedStoreyResourceEntityList && floor.fixedStoreyResourceEntityList.length > 0"/>
          </cloud-floor-tab>
        </cloud-floor>
      </div>
    </div>

  </div>
</template>

<script>
import CloudFloor from '@/components/cloud/CloudFloor'
import CloudFloorTab from '@/components/cloud/CloudFloorTab'
import FloorVideoAD from '@/components/cloud/FloorVideoAD'
import FloorVideo from '@/components/cloud/FloorVideo'
import FloorResource from '@/components/cloud/FloorResource'
import FloorLink from '@/components/cloud/FloorLink'
import { queryBanner, queryFloor } from '@/assets/js/api/cloud'

export default {
  name: 'Home',
  components: {
    FloorLink,
    FloorResource,
    FloorVideo,
    FloorVideoAD,
    CloudFloorTab,
    CloudFloor,
  },
  data () {
    return {
      bannerList: [],
      floorList: [],
      floorData: [],
    }
  },
  created () {
    this.getBanner()
    this.getFloor()
  },
  methods: {
    getBanner () {
      queryBanner().then(res => {
        if (res?.list?.length > 0) {
          this.bannerList = res.list
        }
      })
    },
    getFloor () {
      queryFloor().then(res => {
        this.floorList = res
      })
    },
    tabChange (tab) {
      this.$set(this.floorData, tab.floorIndex, tab.list)
    },
  },
}
</script>

<style lang="scss">
.home-views {
  min-width: 1200px;
  min-height: 600px;
  padding-top: 46px;
  background-image: url("../../assets/images/cloud/banner-bk.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100%;
  background-color: #fff;

  .banner-wrapper {
    margin: 0 auto;
    width: 1200px;
    border-radius: 6px;
    overflow: hidden;

    .banner-link {
      display: block;
      font-size: 0;
      width: 100%;
      height: 100%;

      .image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .floor-wrapper {
    width: 100%;

    &:nth-child(2n) {
      background: $--background-color-base;
    }

    &:nth-child(2n+1) {
      background: #fff;
    }
  }
}
</style>
